import { PLAN_TYPES } from "../../../utils/helpers/subscriptions/plans";
import classes from "./PremiumFeatureModal.module.css";

const PremiumFeatureModal = ({ setOpen, t, onUpgrade, requiredPlan }) => {
  return (
    <div className={classes.premiumBackdrop} onClick={() => setOpen("")}>
      <div className={classes.premiumModal} onClick={(e) => e.stopPropagation()}>
        <button className={classes.premiumCloseBtn} onClick={() => setOpen("")}>✕</button>
        <div className={classes.premiumIcon}>⭐</div>
        <span className={classes.premiumTitle}>
          {requiredPlan === PLAN_TYPES.PREMIUM ? t("premium_content") :  requiredPlan=== PLAN_TYPES.FAMILY ? t("vinni_plus_family") : ""}
        </span>
        <p className={classes.premiumText}>
          {requiredPlan === PLAN_TYPES.PREMIUM ? t("content_only_for_premiums_message") : 
            requiredPlan=== PLAN_TYPES.FAMILY ? t("content_only_for_vinni_family_message") : ""}
        </p>
        <button className={classes.premiumBtn} onClick={() => {onUpgrade(); setOpen("")} }>
          {t("update")}
        </button>
      </div>
    </div>
  );
};

export default PremiumFeatureModal;